import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "src/redux/hooks";

const MAX_WAIT_FRAMES = 20;

export const useHighlightRequiredOnLoad = () => {
  const highlightRequired = useSelector(
    state => state.generatorSlice.lbentry.highlightRequired,
  );
  const latestEntryId = useSelector(
    state => state.generatorSlice.latestEntry.id,
  );
  const [searchParams] = useSearchParams();
  const isNewParam = searchParams.get("new") === "true";
  const { trigger, getValues } = useFormContext();

  useEffect(() => {
    if (!highlightRequired) return;
    let frame = 0;
    let waited = 0;
    // Deferred so it runs after GeneratorFormProvider's reset and field registration
    const run = () => {
      if (Object.keys(getValues()).length === 0 && waited++ < MAX_WAIT_FRAMES) {
        frame = requestAnimationFrame(run);
        return;
      }
      void trigger();
    };
    frame = requestAnimationFrame(run);
    return () => cancelAnimationFrame(frame);
  }, [highlightRequired, latestEntryId, isNewParam, trigger, getValues]);
};
